var _process$env$REACT_AP;
import 'office-ui-fabric-react/dist/css/fabric.css';
import ReactDOM from 'react-dom';
import { initializeIcons, loadTheme } from 'buzz_lib_ui';
import * as serviceWorker from './serviceWorker';
import './index.css';
import { Root } from './Root';
import { jsx as _jsx } from "react/jsx-runtime";
const env = (_process$env$REACT_AP = process.env.REACT_APP_BUZZ_ENV) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'local';
const titleSuffix = env === 'prod' ? '' : " ".concat(env);
document.title = "Buzz".concat(titleSuffix);
initializeIcons();
loadTheme({
  palette: {
    themePrimary: '#2e68ea',
    themeLighterAlt: '#f6f3fb',
    themeLighter: '#ddd0ed',
    themeLight: '#c1aade',
    themeTertiary: '#2e7cea',
    themeSecondary: '#2e54ea',
    themeDarkAlt: '#4a1c83',
    themeDark: '#3f176e',
    themeDarker: '#2e1151',
    neutralLighterAlt: '#f8f8f8',
    neutralLighter: '#f4f4f4',
    neutralLight: '#eaeaea',
    neutralQuaternaryAlt: '#dadada',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c8c8',
    neutralTertiary: '#bab8b7',
    neutralSecondary: '#a3a2a0',
    neutralPrimaryAlt: '#8d8b8a',
    neutralPrimary: '#323130',
    neutralDark: '#605e5d',
    black: '#494847',
    white: '#ffffff'
  },
  //TODO: CL-PERMISSIONS - Look into this after demo, works in most cases but makes context menus confusing
  semanticColors: {
    disabledBodyText: '#444444',
    disabledText: '#444444'
  }
});
ReactDOM.render(/*#__PURE__*/_jsx(Root, {
  env: env
}), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();